import React from 'react';
import { DataTable, StatusBadge } from '../../ui';
import SectionCard from './SectionCard';
import { BADGE_STATUS, RUN_OUTCOME, fmtCount, fmtDateTime, fmtDuration, runPath } from './format';

export default function RecentRuns({ section, navigateTo }) {
  const { data, loading, error, retry, refreshing } = section;

  const columns = [
    {
      key: 'name',
      header: 'Run',
      render: (run) => (
        <div>
          <div className="pqd-strong">{run.name}</div>
          <div className="pqd-muted pqd-small">{run.type === 'plan' ? 'Test plan' : 'Suite'} · #{run.id}</div>
        </div>
      ),
    },
    {
      key: 'status',
      header: 'Status',
      width: 120,
      render: (run) => {
        const o = RUN_OUTCOME[run.outcome] || RUN_OUTCOME.unknown;
        return <StatusBadge status={BADGE_STATUS[o.tone]}>{o.label}</StatusBadge>;
      },
    },
    {
      key: 'results',
      header: 'Results',
      width: 150,
      render: (run) => (
        <span className="pqd-num">
          <span className="is-success">{fmtCount(run.totals.passed)}</span> /{' '}
          <span className="is-danger">{fmtCount(run.totals.failed)}</span>
          <span className="pqd-muted"> of {fmtCount(run.totals.total)}</span>
        </span>
      ),
    },
    { key: 'started', header: 'Started', width: 150, render: (run) => fmtDateTime(run.started_at) },
    { key: 'duration', header: 'Duration', width: 100, render: (run) => (run.state === 'running' ? 'Running' : fmtDuration(run.duration)) },
    { key: 'env', header: 'Environment', width: 130, render: (run) => run.environment?.name || '—' },
    { key: 'by', header: 'Started by', width: 140, render: (run) => run.executed_by?.name || '—' },
  ];

  return (
    <SectionCard
      id="pqd-recent"
      title="Recent run activity"
      subtitle="Test plan runs and standalone suite runs in the selected period. Trigger source (manual, schedule or CI) is not recorded."
      loading={loading}
      error={error}
      onRetry={retry}
      refreshing={refreshing}
      actions={
        <button type="button" className="rt2-link" onClick={() => navigateTo('executions')}>
          View all
        </button>
      }
    >
      <DataTable
        columns={columns}
        rows={(data?.runs || []).map((r) => ({ ...r, key: `${r.type}-${r.id}` }))}
        rowKey="key"
        onRowClick={(run) => navigateTo(runPath(run))}
        emptyTitle="No runs in this period"
        emptyDescription="Runs started from test plans or suites appear here."
      />
    </SectionCard>
  );
}
